import React from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../../../common/hooks/hooks";
import { openProductModal } from "../../../product/components/common/ProductModal/productModalSlice";
import { useFeaturedContent } from "../../hooks/useFeaturedContent";
import RelatedProducts from "../../../product/components/common/RelatedProducts";
import Skeleton from "react-loading-skeleton";

// Breakpoints for page content (wider)
const pageBreakpoints = {
  320: { slidesPerView: 1, spaceBetween: 20 },
  540: { slidesPerView: 2, spaceBetween: 20 },
  768: { slidesPerView: 3, spaceBetween: 30 },
  1024: { slidesPerView: 4, spaceBetween: 30 },
};

const PageFeaturedProducts: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { products, isLoading } = useFeaturedContent();

  const handleOpenQuickView = (productId: number) => {
    dispatch(openProductModal({ productId }));
  };

  if (isLoading) {
    return (
      <div className="page-featured-products">
        <h2 className="page-featured-products__title">
          <Skeleton width={250} />
        </h2>
        <div className="page-featured-products__grid-skeleton">
          {Array.from({ length: 4 }).map((_, i) => (
            <Skeleton key={i} height={300} />
          ))}
        </div>
      </div>
    );
  }

  if (products.length === 0) {
    return null;
  }

  const productIds = products.map((p) => p.id);
  const title = t("featuredContent.productsTitle", "Featured Products");

  return (
    <div className="page-featured-products">
      <RelatedProducts
        productIds={productIds}
        title={title}
        onQuickViewClick={handleOpenQuickView}
        breakpoints={pageBreakpoints}
      />
    </div>
  );
};

export default PageFeaturedProducts;
